module.exports = __webpack_public_path__ + "img/hydrometal.407b85b8.png";